import { default as worktime } from './worktime/services'
import { default as category } from  './category/services'

export default {
    ...worktime,
    ...category,
}